import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createElement, memo, useEffect, useRef, useState } from 'react';
import { KEY_CODES, KEY_DOWN } from '@outdoor-voices/ui/dist/config/constants';
import cc from 'classcat';
import PropTypes from 'prop-types';
import CareInstructions from './CareInstructions';
import ChatAndQuestions from './ChatAndQuestions';
import css from './index.module.scss';
import FabricDetails from './FabricDetails';
import FabricLink from './FabricLink';
import HowItFits from './HowItFits';
import Text from './Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var COMPONENTS = {
  TEXT: Text,
  FABRIC_DETAILS: FabricDetails,
  FABRIC_LINK: FabricLink,
  CARE_INSTRUCTIONS: CareInstructions,
  HOW_IT_FITS: HowItFits,
  CHAT_AND_QUESTIONS: ChatAndQuestions
};

var Tabs = function Tabs(_ref) {
  var productKnowledgeSet = _ref.productKnowledgeSet;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      minHeight = _useState2[0],
      setMinHeight = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      tab = _useState4[0],
      setTab = _useState4[1];

  var rootRef = useRef(null);
  var tablistRef = useRef(null);
  var tabElements = [];
  var panelElements = [];

  var onTabClick = function onTabClick(index) {
    var current = rootRef.current;
    var newHeight = 0;

    _toConsumableArray(current.querySelectorAll('[role="tabpanel"]')).forEach(function (el) {
      newHeight = Math.max(newHeight, el.offsetHeight);
    });

    setMinHeight(newHeight);
    setTab(index);
  };

  useEffect(function () {
    var current = tablistRef.current;

    var onKeyDown = function onKeyDown(event) {
      var ARROW_LEFT = KEY_CODES.ARROW_LEFT,
          ARROW_RIGHT = KEY_CODES.ARROW_RIGHT;

      var tabElements = _toConsumableArray(current.querySelectorAll('button'));

      var tabFocus = tabElements.indexOf(document.activeElement);

      switch (event.key) {
        case ARROW_LEFT:
          tabFocus--; // If we're at the start, move to the end

          if (tabFocus < 0) {
            tabFocus = tabElements.length - 1;
          }

          break;

        case ARROW_RIGHT:
          tabFocus++; // If we're at the end, go to the start

          if (tabFocus >= tabElements.length) {
            tabFocus = 0;
          }

          break;

        default:
          break;
      }

      tabElements[tabFocus].setAttribute('tabindex', 0);
      tabElements[tabFocus].focus();
    };

    current.addEventListener(KEY_DOWN, onKeyDown);
    return function () {
      current.removeEventListener(KEY_DOWN, onKeyDown);
    };
  }, [tablistRef]);
  useEffect(function () {
    var current = rootRef.current;
    var newHeight = 0;

    _toConsumableArray(current.querySelectorAll('[role="tabpanel"]')).forEach(function (el) {
      newHeight = Math.max(newHeight, el.offsetHeight);
    });

    setMinHeight(newHeight);
  }, []);
  productKnowledgeSet.forEach(function (_ref2, idx) {
    var productKnowledges = _ref2.productKnowledges,
        title = _ref2.title;
    var selected = tab === idx;
    var tabId = "tab-".concat(idx);
    var panelId = "panel-".concat(idx);
    tabElements.push( /*#__PURE__*/_jsx("button", {
      "aria-controls": panelId,
      "aria-label": "Click to display the ".concat(title, " panel"),
      "aria-selected": selected ? 'true' : 'false',
      className: cc([css.tab, _defineProperty({}, css.on, selected)]),
      role: "tab",
      onClick: function onClick() {
        onTabClick(idx);
      },
      tabIndex: selected ? 0 : -1,
      children: title
    }, tabId));
    panelElements.push( /*#__PURE__*/_jsx("div", {
      "aria-hidden": selected ? undefined : true,
      "aria-label": title,
      className: cc([css.panel, _defineProperty({}, css.off, !selected)]),
      id: panelId,
      role: "tabpanel",
      tabIndex: "0",
      children: /*#__PURE__*/_jsx("div", {
        className: css.panelContent,
        children: productKnowledges.map(function (_ref5) {
          var id = _ref5.id,
              title = _ref5.title,
              description = _ref5.description,
              type = _ref5.type;
          return /*#__PURE__*/createElement(COMPONENTS[type], {
            key: id,
            title: title,
            description: description
          });
        })
      })
    }, panelId));
  });
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    ref: rootRef,
    children: [/*#__PURE__*/_jsx("div", {
      "aria-label": "Product knowledge tabs",
      className: css.tabList,
      ref: tablistRef,
      role: "tablist",
      children: tabElements
    }), /*#__PURE__*/_jsx("div", {
      className: css.panelsWrap,
      style: {
        minHeight: minHeight
      },
      children: panelElements
    })]
  });
};

Tabs.propTypes = {
  productKnowledgeSet: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string
  }))
};
export default /*#__PURE__*/memo(Tabs);